import SolidButton from "@components/atoms/base-button/SolidButton";
import { translate } from "@locales";
import { useDrawer } from "@models/interactions/use-drawer/index";
import { AddToCartButton, useProductOptions, useCart } from "@shopify/hydrogen";
import { Product } from "@shopify/hydrogen/storefront-api-types";
import classnames from "classnames";
import { useMemo } from "react";

interface Props {
  product: Product;
}

export function PurchaseMarkup({ product }: Props) {
  const { lines } = useCart();
  const { selectedVariant } = useProductOptions();
  const isOutOfStock = selectedVariant?.availableForSale || false;
  const { operations } = useDrawer();
  const isCommingSoonTag = product.tags.includes("comming-soon");

  const currentCartQuantity = useMemo(() => {
    if (!lines) return 0;
    return lines.reduce((total, line) => {
      if (line.merchandise.id === selectedVariant?.id) {
        return total + line.quantity;
      }
      return total;
    }, 0);
  }, [lines, selectedVariant]);

  const isAddToCartAllowed = useMemo(() => {
    if (product.tags.includes("Limited Edition")) {
      return currentCartQuantity + 1 <= 2;
    }
    if (product.tags.includes("Limited Time")) {
      return currentCartQuantity + 1 <= 1;
    }
    return true;
  }, [product, currentCartQuantity]);

  const handleClick = () => {
    if (product?.handle) operations.openDrawer();
  };
  return (
    <>
      {isOutOfStock ? (
        <>
          <AddToCartButton
            variantId={selectedVariant?.id}
            quantity={1}
            className={classnames(
              "w-[170px] h-[45px] border-solid border border-custom-black bg-white font-chivo-regular uppercase tracking-[1.3px] text-black ",
              {
                hidden: !isAddToCartAllowed,
              }
            )}
            disabled={!isAddToCartAllowed}
            accessibleAddingToCartLabel="Adding item to your cart"
            onClick={handleClick}
          >
            {isCommingSoonTag
              ? translate("shop.cart.coming-soon")
              : !product.tags.includes("Preorder")
              ? translate("shop.cart.add-to-cart")
              : translate("shop.cart.pre-order")}
          </AddToCartButton>
          <AddToCartButton
            variantId={selectedVariant?.id}
            quantity={1}
            className={classnames(
              "w-[170px] flex items-center justify-center uppercase text-white rounded-sm font-medium text-center py-3 px-6 h-[45px] leading-none bg-black opacity-50 cursor-not-allowed ",
              {
                hidden: isAddToCartAllowed,
              }
            )}
            disabled={!isAddToCartAllowed}
            accessibleAddingToCartLabel="Adding item to your cart"
            onClick={handleClick}
          >
            {isCommingSoonTag
              ? translate("shop.cart.coming-soon")
              : !product.tags.includes("Preorder")
              ? translate("shop.cart.add-to-cart")
              : translate("shop.cart.pre-order")}
          </AddToCartButton>
        </>
      ) : (
        <SolidButton className="w-[170px] h-[45px]" disabled>
          {translate("shop.product.sold-out")}
        </SolidButton>
      )}
    </>
  );
}
